var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 19,
    viewBox: "0 0 3 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 171"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#0A0F0D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12_2",
    cx: 1.5,
    cy: 9.5,
    r: 1.5,
    fill: "#0A0F0D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12_3",
    cx: 1.5,
    cy: 17.5,
    r: 1.5,
    fill: "#0A0F0D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/dots-icon.39f31ccec92161c39e51436fb29a883e.svg";
export { ForwardRef as ReactComponent };